import { DeleteButton } from '@common/components/forms';
import { ISignatureStore } from '@hospital/stores';
import { observer } from "mobx-react";
import React, { useState } from 'react';
import { Button, Row } from 'react-bootstrap';
import { UserProfileSignatureAdd } from './UserProfileSignatureAdd';
import { UserProfileSignatureDelete } from './UserProfileSignatureDelete';
export interface IUserProfileSignatureProps {
    store: ISignatureStore;
    readOnly?: boolean;
    isActive: boolean;
}

export const UserProfileSignature = observer(({ store, readOnly, isActive }: IUserProfileSignatureProps) => {
    const [showAddSignatureModal, setShowAddSignatureModal] = useState<boolean>(false);
    const [showDeleteSignatureModal, setShowDeleteSignatureModal] = useState<boolean>(false);

    const hideModals = () => {
        setShowAddSignatureModal(false);
        setShowDeleteSignatureModal(false);
    }
    const setSignature = async (imageUrl: string) =>
        await store.saveVetSignature(imageUrl);

    const deleteSignature = async () =>
        await store.deleteVetSignature().finally(hideModals);

    return (<>
        {!store.hasSignature && <>
            <Row className="pt-1">
                <em>No signature has been saved for this user.</em>
            </Row>
            <Row className="pt-3">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    {!readOnly && isActive && <>
                        <Button
                            aria-label="add signature"
                            variant="outline-primary"
                            onClick={() => setShowAddSignatureModal(true)}>Add New Signature</Button>
                    </>}
                </div>
            </Row>
        </>}
        {store.hasSignature && <>
            <Row className="pt-3">
                <img src={store.signatureUrl} alt={store.signatureName} />
            </Row>
            <Row className="pt-3">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    {!readOnly && isActive && <>
                        <Button
                            aria-label="update signature"
                            variant="outline-primary"
                            onClick={() => setShowAddSignatureModal(true)}>Update Signature</Button>
                        <DeleteButton aria-label={`delete signature`} onClick={() => setShowDeleteSignatureModal(true)} />
                    </>}
                </div>
            </Row>
        </>}
        {
            isActive &&
            <UserProfileSignatureAdd
                onSubmit={setSignature}
                onCancel={hideModals}
                title="Save New Signature"
                visible={showAddSignatureModal}
                updateInProgress={store.signatureIsBeingUpdated}
            />
        }
        {
            isActive &&
            <UserProfileSignatureDelete
                onSubmit={deleteSignature}
                onCancel={hideModals}
                show={showDeleteSignatureModal}
                busy={store.signatureIsBeingUpdated}
            />
        }
    </>
    )
});
